import api from '@/services/api'

const state = {
    companies: [],
    currentCompany: JSON.parse(localStorage.getItem('currentCompany')) || null,
    allCompanies: []
}

const mutations = {
    SET_COMPANIES(state, companies) {
        state.companies = companies
    },
    SET_ALL_COMPANIES(state, companies) {
        state.allCompanies = companies
    },
    SET_CURRENT_COMPANY(state, company) {
        state.currentCompany = company
        if (company) {
            localStorage.setItem('currentCompany', JSON.stringify(company))
        } else {
            localStorage.removeItem('currentCompany')
        }
    },
    ADD_COMPANY(state, company) {
        state.allCompanies.push(company)
    },
    UPDATE_COMPANY(state, updatedCompany) {
        const index = state.allCompanies.findIndex(c => c.id === updatedCompany.id)
        if (index !== -1) {
            state.allCompanies.splice(index, 1, updatedCompany)
        }
    },
    REMOVE_COMPANY(state, companyId) {
        state.allCompanies = state.allCompanies.filter(c => c.id !== companyId)
        if (state.currentCompany?.id === companyId) {
            state.currentCompany = null
            localStorage.removeItem('currentCompany')
        }
    }
}

const actions = {
    async fetchMyCompanies({ commit }) {
        try {
            const response = await api.get('/companies/my-companies')
            commit('SET_COMPANIES', response.data)
            return { success: true, companies: response.data }
        } catch (error) {
            const message = error.response?.data?.error || 'Failed to fetch companies'
            return { success: false, error: message }
        }
    },

    async fetchAllCompanies({ commit }) {
        try {
            const response = await api.get('/companies')
            commit('SET_ALL_COMPANIES', response.data)
            return { success: true, companies: response.data }
        } catch (error) {
            const message = error.response?.data?.error || 'Failed to fetch companies'
            return { success: false, error: message }
        }
    },

    async createCompany({ commit }, companyData) {
        try {
            const response = await api.post('/companies', companyData)
            commit('ADD_COMPANY', response.data)
            return { success: true, company: response.data }
        } catch (error) {
            const message = error.response?.data?.error || 'Failed to create company'
            return { success: false, error: message }
        }
    },

    async updateCompany({ commit }, { id, data }) {
        try {
            await api.put(`/companies/${id}`, data)
            const updatedCompany = { id, ...data }
            commit('UPDATE_COMPANY', updatedCompany)
            return { success: true }
        } catch (error) {
            const message = error.response?.data?.error || 'Failed to update company'
            return { success: false, error: message }
        }
    },

    async deleteCompany({ commit }, companyId) {
        try {
            await api.delete(`/companies/${companyId}`)
            commit('REMOVE_COMPANY', companyId)
            return { success: true }
        } catch (error) {
            const message = error.response?.data?.error || 'Failed to delete company'
            return { success: false, error: message }
        }
    },

    async testConnection({ state }, companyId) {
        try {
            const response = await api.get(`/companies/${companyId}/test-connection`)
            return { success: true, data: response.data }
        } catch (error) {
            const data = error.response?.data
            const message =
                data?.details ||
                data?.error ||
                error.message ||
                'Connection test failed'
            return { success: false, error: message }
        }
    },

    setCurrentCompany({ commit }, company) {
        commit('SET_CURRENT_COMPANY', company)
    }
}

const getters = {
    companies: state => state.companies,
    allCompanies: state => state.allCompanies,
    currentCompany: state => state.currentCompany,
    hasCompanies: state => state.companies.length > 0
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}